import * as React from 'react'
import { Octicon } from '../../octicons'
import * as OcticonSymbol from '../../octicons/octicons.generated'
import { LinkButton } from '../link-button'

export function renderUnmergedFilesSummary(conflictedFilesCount: number) {
  // localization, it burns :vampire:
  const message =
    conflictedFilesCount === 1
      ? `1 conflicted file`
      : `${conflictedFilesCount} conflicted files`
  return <h3 className="summary">{message}</h3>
}

export function renderAllResolved() {
  return (
    <div className="all-conflicts-resolved">
      <div className="green-circle">
        <Octicon symbol={OcticonSymbol.check} />
      </div>
      <div className="message">All conflicts resolved</div>
    </div>
  )
}

export function renderShellLink(openThisRepositoryInShell: () => void) {
  return (
    <div>
      <LinkButton onClick={openThisRepositoryInShell}>
        Open in command line,
      </LinkButton>{' '}
      your tool of choice, or close to resolve manually.
    </div>
  )
}
